module.exports = __webpack_public_path__ + "img/logo5.f7da52f5.png";